import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import { TBiofouling2Place } from '../@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';

export type TBFL2C1Item1 = {
    descriptionOfAnyObservedReduction: string;
};

export type TBFL2C1Item2 = {
    descriptionOfOperation: string;
};

export type TBFL2C1Item3 = {
    locationOfAnyInstances: string;
};

export type TBFL2C1Item4 = {
    recordsOfMaintenance: string;
    maintenanceAttachment: string;
};

export type TBFL2C1Item5 = {
    contingencyActions: string;
};

export type TBFL2C1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2C1;
        item1: TBFL2C1Item1;
        item2: TBFL2C1Item2;
        item3: TBFL2C1Item3;
        item4: TBFL2C1Item4;
        item5: TBFL2C1Item5;
    };

export type TBFL2C = TBFL2C1;

const BFL2C_DEFAULTS: {
    C1: TBFL2C1;
} = {
    C1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        recordCode: EBFL2RecordCode.BFL2C1,
        item1: {
            descriptionOfAnyObservedReduction: '',
        },
        item2: {
            descriptionOfOperation: '',
        },
        item3: {
            locationOfAnyInstances: '',
        },
        item4: {
            recordsOfMaintenance: '',
            maintenanceAttachment: ' ',
        },
        item5: {
            contingencyActions: '',
        },
    },
};

export { BFL2C_DEFAULTS };
